import React from 'react';
import { styled, Typography } from '@mui/material';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

const StyledHeader = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.grey[800],
  lineHeight: 1.2,
  fontSize: '32px',
  [theme.breakpoints.up('sm')]: { fontSize: '48px' },
  [theme.breakpoints.up('md')]: { fontSize: '60px' },
}));

export const ResourcesHeader = () => {
  const { translation } = useTranslationContext();

  return (
    <StyledHeader id="resources__header">
      {translation('download_the_mobile_app_title')}
    </StyledHeader>
  );
};
